<template>
  <div id="cat" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-4">
          <div class="vx-col">
            <vs-button @click="isCreateReceiver()" class="bg_l_green">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
              {{ $t("CreateNewReceiver") }}
            </vs-button>
          </div>
        </div>
        <create-popup
          :show="showCreateReceiver"
          @finish="onfinish"
        ></create-popup>
        <modify-popup
          :show="showModifyReceiver"
          :receiverForModify="receiverForModify"
          @finish="onfinish"
        ></modify-popup>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('Name') },
                { title: $t('Email') },
                { title: $t('PhoneNumber') },
                { title: $t('Action') }
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 30%">
                  {{ row.fullName }}
                </td>
                <td style="width: 30%">
                  {{ row.emailAddress }}
                </td>
                <td style="width: 20%">
                  {{ row.phoneNumber }}
                </td>
                <td style="width: 10%">
                  <vs-button
                    radius
                    color="success"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-edit"
                    @click.prevent="isModifyReceiver(row)"
                    class="d-inline"
                  ></vs-button>
                  <vs-button
                    radius
                    color="danger"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-x"
                    @click.prevent="isDeleteReceiver(row)"
                    class="d-inline mx-4"
                  ></vs-button>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import CreatePopup from "./CreatePopup.vue";
import ModifyPopup from "./ModifyPopup.vue";

export default {
  name: "",
  components: {
    CreatePopup,
    ModifyPopup,
    DataGrid
  },
  data() {
    return {
      showCreateReceiver: false,
      showModifyReceiver: false,
      gridDataSource: {
        type: "app",
        service: "Notifications/api/Receivers"
      },
      gridSearchData: {},
      receiverForModify: {}
    };
  },

  methods: {
    ...mapActions({
      deleteReceiver: "notification/deleteReceiver"
    }),
    isCreateReceiver() {
      this.showCreateReceiver = true;
    },
    onfinish() {
      this.showCreateReceiver = false;
      this.showModifyReceiver = false;
      this.$refs.grid.renderGrid();
    },
    isModifyReceiver(receiver) {
      this.receiverForModify.id = receiver.id;
      this.receiverForModify.fullName = receiver.fullName;
      this.receiverForModify.emailAddress = receiver.emailAddress;
      this.receiverForModify.phoneNumber = receiver.phoneNumber;
      this.showModifyReceiver = true;
    },
    isDeleteReceiver(receiver) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر"
      }).then(result => {
        if (result.value) {
          this.deleteReceiver(receiver.id).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    }
  }
};
</script>
